import StatusNotification from './status-notification';
import {connect} from 'react-redux';
import {dismissCitizenNotification} from 'src/redux/college-search/actions';
import {Store} from 'src/types/store';

export default connect(
  (state: Store) => ({
    user: state.collegeSearch.user,
  }),
  {
    dismissCitizenNotification,
  }
)(StatusNotification);
